import './index.css';

import MenuSuperior from "../Components/MenuSuperior"
import HeroStart from "../Components/HeroStart";
import SobreNos from "../Components/SobreNos";
import Equipe from "../Components/Equipe";
import Vagas from "../Components/Vagas";
import Destaques from "../Components/Destaques";
import Footer from "../Components/Footer";

const Index = () => {
    return (
        <div className="index">
            <MenuSuperior />
            <HeroStart />
            <SobreNos buttonVisible={true} />
            <Equipe />
            <Vagas />
            <Destaques />
            <Footer />
        </div>
    );
}
export default Index;